export default "__VITE_ASSET__tNNTw2nJ__"